import { useEffect, useState } from "react"

/**
 * Returns the bottom inset (px) currently consumed by the on-screen
 * keyboard on mobile. Subscribes to `visualViewport` resize events so
 * the composer can sit flush above the keyboard.
 *
 * Falls back to 0 when `visualViewport` is unavailable (older browsers,
 * SSR). Safe to call on desktop — returns 0 there too.
 */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0)

  useEffect(() => {
    const vv =
      typeof window !== "undefined" ? window.visualViewport : undefined
    if (!vv) return

    const update = () => {
      const offset = window.innerHeight - vv.height - vv.offsetTop
      setInset(Math.max(0, Math.round(offset)))
    }

    update()
    vv.addEventListener("resize", update)
    vv.addEventListener("scroll", update)
    return () => {
      vv.removeEventListener("resize", update)
      vv.removeEventListener("scroll", update)
    }
  }, [])

  return inset
}
